import React from 'react';
import Icon from '../../../components/AppIcon';

const AgencyFilters = ({ searchQuery, onSearchChange, statusFilter, onStatusChange, currentLanguage = 'fr' }) => {
  const labels = {
    fr: {
      search: 'Rechercher une agence...',
      allStatuses: 'Tous les statuts',
      active: 'Actif',
      trial: 'Essai',
      suspended: 'Suspendu',
      inactive: 'Inactif',
    },
    ar: {
      search: 'البحث عن وكالة...',
      allStatuses: 'جميع الحالات',
      active: 'نشط',
      trial: 'تجريبي',
      suspended: 'معلق',
      inactive: 'غير نشط',
    }
  };

  const l = labels?.[currentLanguage] || labels?.fr;

  return (
    <div className="flex flex-col sm:flex-row gap-3">
      {/* Search */}
      <div className="relative flex-1">
        <Icon name="Search" size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          placeholder={l?.search}
          className="w-full pl-9 pr-4 py-2.5 rounded-lg border border-border bg-background text-foreground text-sm placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors"
        />
        {searchQuery && (
          <button
            onClick={() => onSearchChange('')}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
          >
            <Icon name="X" size={14} />
          </button>
        )}
      </div>

      {/* Status filter */}
      <select
        value={statusFilter}
        onChange={(e) => onStatusChange(e?.target?.value)}
        className="px-3 py-2.5 rounded-lg border border-border bg-background text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors min-w-[160px]"
      >
        <option value="all">{l?.allStatuses}</option>
        <option value="active">{l?.active}</option>
        <option value="trial">{l?.trial}</option>
        <option value="suspended">{l?.suspended}</option>
        <option value="inactive">{l?.inactive}</option>
      </select>
    </div>
  );
};

export default AgencyFilters;
